import React from 'react';

import { useTranslation } from 'react-i18next';
import LoginLayout from '../components/LoginLayout';
import LoginCard from '../components/LoginCard';
import LoginButton from '../components/LoginButton';
import Heading from '../../../generic-components/Heading';
import { NOT_FINISHED_SIGN_UP_SCREEN_DATA } from '../constants';

const NotFinishingSignUp = () => {
  const {
    LOGIN_CARD, HEADING, TEXT, LOGIN_BTN, ACTIONS,
  } = NOT_FINISHED_SIGN_UP_SCREEN_DATA;

  const { t } = useTranslation();

  return (
    <LoginLayout backButton backDestination={ACTIONS.BACK}>
      <LoginCard className={LOGIN_CARD.CLASS_NAME} backgroundColor={LOGIN_CARD.BACKGROUND}>
        <Heading title={t(HEADING.TITLE)} className={HEADING.CLASS_NAME} />
        <Heading
          title={t(TEXT.TITLE)}
          className={TEXT.CLASS_NAME}
        />
        <LoginButton title={t(LOGIN_BTN.TITLE)} className={LOGIN_BTN.CLASS_NAME} />
      </LoginCard>
    </LoginLayout>
  );
};

export default NotFinishingSignUp;
